"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var VideoContainer_1 = __importDefault(require("../../../styles/VideoContainer"));
var Layout = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 64px);\n  transition: opacity 0.8s ease, transform 0.8s ease;\n  opacity: ", ";\n  transform: translateX(15%);\n\n  ", ".show-controls & {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 64px);\n  transition: opacity 0.8s ease, transform 0.8s ease;\n  opacity: ", ";\n  transform: translateX(15%);\n\n  ", ".show-controls & {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"])), function (_a) {
    var isPlaying = _a.isPlaying;
    return (isPlaying ? 0 : 1);
}, VideoContainer_1.default);
exports.default = Layout;
var templateObject_1;
